import { Cms, Pay } from "@/api";
import mdUtils from '@/utils/mdUtils'
import { Toast,Dialog  } from "vant";
import axios from '@/services'
import router from '@/router'
class PayServices {
  
  constructor() {
    this.paymentId = ''
    this.payAmount = 0
  }
  // payOpts = {
  //   paymentId: '',
  //   payAmount: 0,
  //   payMsg: '',
  //   payType:  1 inWx 2 wx 3 ali
  //   payFor: 1 需方订单 2 需方框架 3 付费阅读 4 打赏
  // }

  async pay(payOpts) {
    let { paymentId, payAmount, payMsg, payType, payFor } = payOpts

    this.paymentId = paymentId
    this.payAmount = payAmount
    
    let buildOpts 
    if (mdUtils.isWeiXin()) {
      buildOpts = this.getInsideWxOpts(payMsg, payFor); 
    } else {
      if (payType === 'wx') {
        buildOpts = this.getH5Opts_Wx(payMsg, payFor)
      } else if (payType === 'ali') {
        buildOpts = this.getH5Opts_Ali(payMsg, payFor)
      }
    }

    let paySign = await this.buildPay(buildOpts)

    if (mdUtils.isWeiXin()) {
      return this.insideWxPay(paySign)
    } else {
      if (payType === 'wx') {
        this.payInH5_Wx(paySign)
      } else if (payType === 'ali') {
        this.payInH5_Ali_pc(paySign)
      }
    }
  }

  buildPay(buildOpts) {
    return axios.request(Pay.PayBuild, buildOpts);
    // return axios.request('http://api.pay.51mydao.com/Pay/Build', buildOpts);
  }

  getInsideWxOpts(msg, payFor) {
    return {
      BizNo: this.paymentId,
      For: payFor,
      ThirdPaymentPlatform: 8,
      Method: 1,
      Subject: msg,
      Body: msg,
      Amount: this.payAmount
    }
  }

  getH5Opts_Wx(msg, payFor) {
    let renturnUrl = this.getReturnUrl()
    return {
      BizNo: this.paymentId,
      For: payFor,
      ThirdPaymentPlatform: 16,
      Method: 1,
      Subject: msg,
      Body: msg,
      Amount: this.payAmount,
      ReturnUrl: renturnUrl
    }
  }

  getH5Opts_Ali(msg, payFor) {
    let renturnUrl = this.getReturnUrl()
    return {
      BizNo: this.paymentId,
      For: payFor,
      ThirdPaymentPlatform: 32,
      Method: 1,
      Subject: encodeURIComponent(msg),
      Body: encodeURIComponent(msg),
      Amount: this.payAmount,
      ReturnUrl: renturnUrl
    }
  }

  payInH5_Ali_pc(paySign) {
    if (paySign) {
      router.push({name: 'pay', params: {content: paySign}})
    }
  }

  payInH5_Wx(paySign) {
    if (paySign && paySign.MWebUrl) {
      let backUrl = encodeURIComponent('http://api.pay.51mydao.com/pay/return?out_trade_no=' + paySign.PaymentId)
      // let url = paySign.MWebUrl + '&redirect_url=' + backUrl;
      let url = paySign.MWebUrl + '&redirect_url=' + backUrl;
     
      window.location.href = url

      // alert('https://go.51mydao.com/go='+encodeURIComponent(url)+'?type=0')
      // window.location.href ='https://go.51mydao.com/go='+encodeURIComponent(url)+'?type=0';
    }
  }

  getReturnUrl() {
    let url = window.location.href.replace(/\?.+$/, '')
    let opts = this.urlGet()
    // let id = opts.id 

    // if (id.indexOf('-')>= 0) {
    //   opts.id = id.substr(0,id.indexOf('-'))
    // }
    if (opts.wx) {
      delete opts.wx
    }
    if (opts.Trade_Status) {
      delete opts.Trade_Status
    }
    if (opts.BizNo) {
      delete opts.BizNo
    }
    return url + this.urlSet(opts)
  }

  urlGet(name) {
    let url = window.location.href
    let result = {},
        res = {};

    if (url.split('?').length>1) {
      var str = url.split('?')[1],
        items = str.split('&')
        
      for(var i = 0, len = items.length; i <len; ++i){
        res = items[i].split("=");
        result[res[0]] = res[1];
      }
      if (name) return result[name]
    }
    
    return result;
  }

  urlSet(opts) {
    let result = '?'
    
    for(let key in opts) {
      result += key + '=' + opts[key] + '&'
    }
    
    result = result.replace(/&$/, '')
    return result
  }

  insideWxPay(paySign) {
    if (typeof WeixinJSBridge === "undefined") {
      Toast("非微信内，支付失败");
      return;
    }
    let reqMsg = {
      appId: paySign.AppId, //公众号名称，由商户传入
      timeStamp: paySign.Timestamp, //时间戳，自1970年以来的秒数
      nonceStr: paySign.NonceStr, //随机串
      package: paySign.Package,
      signType: paySign.SignType, //微信签名方式：
      paySign: paySign.PaySign //微信签名
    };
    var that = this;

    Toast.loading({
      mask: true,
      message: "支付中..."
    });

    return new Promise((rel, rej) => {
      WeixinJSBridge.invoke("getBrandWCPayRequest", reqMsg, function(res) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          var tryTimes = 0;
          let timer = setInterval(function() {
            tryTimes++;
            if (tryTimes > 5) {
              Toast("服务器异常，请刷新页面！");
              clearInterval(timer);
            }
            that.checkIsPaySuccess(that.paymentId).then(() => {
              rel()
              clearInterval(timer);
              that.paymentId = ''
              that.payAmount = 0
            })
          }, 500);
        } else {
          rej()
          Toast.clear();
          Toast("微信支付失败");
          that.paymentId = ''
          that.payAmount = 0
        }
      });
    })
  }

  handleBack(queryOpt) {
    // let _id = queryOpt.id + ''

    // if (_id.indexOf('-')) {
    //   this.paymentId = _id.split('-')[1]
    // } 
    if (queryOpt.BizNo) {
      if (queryOpt.Trade_Status == 'SUCCESS') {
        this.paymentId = queryOpt.BizNo
      }
    }

    if (this.paymentId) {
      let that = this
      Dialog.confirm({
        title: '请确认支付已完成',
      }).then(() => {
        that.checkIsPaySuccess(this.paymentId).then((res) => {
          // 1 订阅 2 打赏
          if (res.PaymentFor == 1) {
            window.location.href = this.getReturnUrl()
          }
          
        })
        that.paymentId = ''
        that.payAmount = 0
      }).catch(() => {
        that.paymentId = ''
        that.payAmount = 0
      });
    } 
  }

  checkIsPaySuccess(paymentId) {
    return new Promise((rel, rej) => {
      axios.request(Cms.PaymentGetById, { Id: paymentId }, false)
      .then(function(paymentDetail) {
        if (paymentDetail.Status === 2) {
          Toast("支付成功！");
          rel(paymentDetail)
          
        }
      })
      .catch(function() {
        rej()
        Toast.clear();
      });
    })
  }
}

export default new PayServices()